import { useContext, useEffect, useState, useRef } from "react";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { fakeTableList } from "./parts";
import { httpAPI_RET002 } from "./api/request";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { GlobalContext } from "../../context/globalContext";
import { changeZipcodeFormat } from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";
import { Prefectures } from "../../assets/data/Constants";
import _ from "lodash";

/**
 * SCRW410002合算制度利用申出の手続き（機構への提出確認）
 * @return SCRW410002
 */
const SCRW410002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);

  //業務用Contextを更新するState
  const { state: businessState } = useContext(BusinessContext);
  //fakeTableList
  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_RET002({
        contractorNo: businessState.common?.contractorNo,
        applyId: location.state?.applyId ?? businessState.job_36?.applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableListRef.current;

        let staffNo = resArr.find((item) => item.keyword === "staffNo")!;
        let facilityName = resArr.find(
          (item) => item.keyword === "facilityName"
        )!;
        let staffNameKanji = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        let birthday = resArr.find((item) => item.keyword === "birthday")!;
        let maePeriodDate = resArr.find(
          (item) => item.keyword === "maePeriodDate"
        )!;
        let retireDate = resArr.find((item) => item.keyword === "retireDate")!;
        let retireProcedureReason = resArr.find(
          (item) => item.keyword === "retireProcedureReason"
        )!;
        let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
        let address = resArr.find((item) => item.keyword === "address")!;
        let tel = resArr.find((item) => item.keyword === "tel")!;
        let email = resArr.find((item) => item.keyword === "email")!;
        let agentEmail = resArr.find((item) => item.keyword === "agentEmail")!;

        staffNo.text = (res.staffNo ?? "") + ":" + (res.staffNameKanji ?? "");
        facilityName.text = res?.facilityName;
        staffNameKanji.text = res?.staffNameKanji;
        birthday.text = res?.birthday;
        maePeriodDate.text =
          (res?.maePeriodYear ?? "") +
          "年" +
          (res?.maePeriodMonth ?? "") +
          "ヶ月";
        retireDate.text = res?.retireDate;
        retireProcedureReason.text = res?.retireProcedureReason;
        zipcode.text = changeZipcodeFormat(res?.zipcode);
        address.text =
          (TkGetCode(Prefectures, res.prefectureCd) ?? "") +
          (res.addressCity ?? "") +
          (res.addressOthers ?? "");
        tel.text = res?.tel;
        email.text = res?.email;
        agentEmail.text = res?.agentEmail;
        agentEmail.showLine = res.email !== res.agentEmail;

        const powerOfAttorney = resArr.find(
          (item) => item.keyword === "powerOfAttorney"
        );
        if (powerOfAttorney) {
          const powerOfAttorneyFile = res.fileList?.find(
            (item) => item.formClass === "43"
          );
          powerOfAttorney.base64filedata = powerOfAttorneyFile?.fileBase64;
          powerOfAttorney.dataname = powerOfAttorneyFile?.fileName;
          powerOfAttorney.showLine = true;
        }

        setStateFakeTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW410002PageForTest">
      <Box>
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLW410002_01}
        </TkInfoManual>
      </Box>
      <Box>
        <TkFakeTable
          list={stateFakeTableList}
          ruleSchema={{}}
          showButton={false}
        />
      </Box>
      <Box>
        <Stack
          sx={{ marginTop: 3 }}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <TkBackButton></TkBackButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default SCRW410002;
